<template>
  <div class="login-change-language" @click="showlanguage">
      <img class="flagicon" :src="currentFlag" />

    <b-modal v-model="showLanguages" centered scrollable hide-footer no-fade hide-header>
      <b-list-group flush>
        <b-list-group-item class="p-2"
          href="#"
          v-for="(value, key) in locales"
          :key="key"
          @click="setLocale(key)"
        >
          <b-row>
            <b-col cols="6" class="text-right no-right-gutter">
              <img class="flagicon" :src="getFlag(key)" />
            </b-col>
            <b-col cols="6" class="text-left no-left-gutter">{{value}}</b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showLanguages: false,
      locale: this.$i18n.locale,
      locales: this.$store.state.lang.locales
    };
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.showLanguages = false;
    },
    getFlag(locale) {
      return "/img/flags/" + locale + ".png";
    },
    showlanguage() {
      this.showLanguages = true;
    }
  },
  computed: {
    getSelected() {
      return this.$i18n.locale;
    },
    getSelectedValue() {
      return this.locales[this.$i18n.locale];
    },
    currentFlag() {
      return "/img/flags/" + this.$i18n.locale + ".png";
    }
  }
};
</script>
